import { render, staticRenderFns } from "./TaskListView.vue?vue&type=template&id=605167f6"
import script from "./TaskListView.vue?vue&type=script&lang=js"
export * from "./TaskListView.vue?vue&type=script&lang=js"
import style0 from "./TaskListView.vue?vue&type=style&index=0&id=605167f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports